import { Injectable } from '@angular/core';
import { OrigamiResponse, ServiceBase } from '@app/origami-api/services/base/service.base';
import { ErrorCode } from '@app/origami-api/constants/error-codes';
import { Observable } from 'rxjs';
import { Topic } from '@app/origami-api/utils/topic-utils';

export namespace StudyProfileServiceModel {
  export type StudyProfile = Topic;

  export interface StudyProfileView {
    ViewFilterId: string;
    ViewFilterDisplayName: string;
    RecordsCount: string;
  }

  export interface StudyProfilesResponse {
    Records: StudyProfileServiceModel.StudyProfile[];
    TotalRowCount: number;
    PageNumber: number;
  }
}

export namespace StudyProfileServiceOptions {
  export interface GetStudyProfiles {
    viewFilter: string;
    start?: number;
    limit?: number;
    orderBy?: string;
    viewMode: StudyProfileViewMode;
    siteId?: number;
    studyProfileId?: number;
  }

  export interface GetStudyProfileViews {
    siteId: number;
    viewMode: StudyProfileViewMode;
  }

  export enum StudyProfileViewMode {
    BySponsor = 1,
  }
}

@Injectable()
export class StudyProfileService extends ServiceBase {
  serviceUrl = 'StudyProfileService.svc';

  getStudyProfileList(
    params: StudyProfileServiceOptions.GetStudyProfiles,
    silentErrorCodes?: ErrorCode[],
  ): Observable<OrigamiResponse<StudyProfileServiceModel.StudyProfilesResponse>> {
    return this.origamiPost('/GetStudyProfiles', params, null, silentErrorCodes, true);
  }

  createStudyProfile(body, silentErrorCodes?: ErrorCode[]): Observable<OrigamiResponse<any>> {
    return this.origamiPost('/CreateStudyProfile', body, null, silentErrorCodes, true);
  }

  editStudyProfile(body, silentErrorCodes?: ErrorCode[]): Observable<OrigamiResponse<any>> {
    return this.origamiPost('/EditStudyProfile', body, null, silentErrorCodes, true);
  }

  getStudyProfileViewList(
    body: StudyProfileServiceOptions.GetStudyProfileViews,
  ): Observable<OrigamiResponse<StudyProfileServiceModel.StudyProfileView[]>> {
    return this.origamiPost('/GetStudyProfileViews', body, null, null, true);
  }

  deleteStudyProfile(body, silentErrorCodes?: ErrorCode[]): Observable<OrigamiResponse<any>> {
    return this.origamiPost('/DeleteStudyProfile', body, null, silentErrorCodes, true);
  }
}
